import {useEffect, useState} from 'react';
import {useMsal} from '@azure/msal-react';

export const useMsalHandleRedirect = () => {
  const {instance} = useMsal();
  const [isHandled, setIsHandled] = useState(false);

  useEffect(() => {
    instance.handleRedirectPromise().then(_ => setIsHandled(true));
  }, [instance, setIsHandled]);
  return isHandled;
};
